
import { ISymbolValues } from "../../../core/extra/MiniPayTable";
import { GameData } from "./GameData";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class InitData extends GameData {

    private _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];

    get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    public get isRestoreState(): boolean {
        return this.raw.isRestoreState;
    }

    public get symbolValues(): ISymbolValues {
        return this.raw.symbolValues;
    }

    setData(data: any) {
        this._featureBuyTimesBetValue = data.featureBuyTimesBetValue;
        super.setData(data);
    }
}
